export const ActionTypes = {
  APPLY_FILTER_TO_TRACKABLE: "applyFilterToTrackable",
  CLEAR_APPLIED_FILTER_FOR_TRACKABLE: "clearAppliedFilterForTrackable",
};

/** @param {{ filter: object, trackableId: number|string }} payload */
export const applyFilterToTrackable = (payload) => ({
  type: ActionTypes.APPLY_FILTER_TO_TRACKABLE,
  payload,
});

/** @param {{ trackableId: number|string }} payload */
export const clearAppliedFilterForTrackable = (payload) => ({
  type: ActionTypes.CLEAR_APPLIED_FILTER_FOR_TRACKABLE,
  payload,
});